interface Props {
  avgCommission: number;
}

const tiers = [
  { label: "Standard Resellers", rate: "8–12%", description: "General marketplace resellers and buyers", icon: "ri-user-line", color: "bg-gray-50 text-gray-600" },
  { label: "Verified Influencers", rate: "12–18%", description: "Social media influencers with verified audiences", icon: "ri-star-line", color: "bg-rose-50 text-rose-500" },
  { label: "Wholesale Partners", rate: "5–8%", description: "Bulk buyers placing orders of 500+ units", icon: "ri-store-2-line", color: "bg-orange-50 text-orange-500" },
  { label: "Premium Members", rate: "15–20%", description: "StarBookPrime premium membership holders", icon: "ri-vip-crown-line", color: "bg-amber-50 text-amber-500" },
];

export default function CommissionOverview({ avgCommission }: Props) {
  return (
    <div className="bg-white rounded-xl border border-gray-100 p-5">
      <div className="flex items-center justify-between mb-5">
        <div>
          <h2 className="text-base font-bold text-gray-900">Commission Structure</h2>
          <p className="text-xs text-gray-400 mt-0.5">Your current average commission rate across all listings</p>
        </div>
        <div className="text-right">
          <div className="text-3xl font-extrabold text-orange-500">{avgCommission}%</div>
          <div className="text-xs text-gray-400">avg. commission</div>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {tiers.map((tier) => (
          <div key={tier.label} className="flex items-start gap-3 p-3 rounded-xl bg-gray-50/60 border border-gray-100">
            <div className={`w-9 h-9 flex items-center justify-center rounded-lg flex-shrink-0 ${tier.color}`}>
              <i className={`${tier.icon} text-base`} />
            </div>
            <div className="min-w-0">
              <div className="flex items-center justify-between gap-2">
                <p className="text-sm font-semibold text-gray-900 truncate">{tier.label}</p>
                <span className="text-sm font-bold text-orange-500 whitespace-nowrap">{tier.rate}</span>
              </div>
              <p className="text-xs text-gray-400 mt-0.5">{tier.description}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-4 p-3 bg-orange-50 rounded-xl border border-orange-100">
        <p className="text-xs text-orange-700 flex items-start gap-2">
          <i className="ri-information-line mt-0.5 flex-shrink-0" />
          Commission rates are set per product. Click the commission % on any listing above to edit it. Higher rates attract more resellers and influencers to promote your products.
        </p>
      </div>
    </div>
  );
}
